export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const PUBLIC_BASE_URL = "";

export const fetchPublic = (path: string) => {
  return fetch(`${path}`).then((res) => res.json());
};
